const { compose, map, tap } = require('ramda')

module.exports = function dispatcherWriteOp (stream, requestFn) {
  return compose(map(tap(stream.put)), requestFn)
}
